import React from 'react'
import {Redirect, useLocation} from 'react-router-dom'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Header from './assessment-header'
import Properties from './AssessmentProperties'
import Sections from './assessment-sections'
import Section from './assessment-section'
import Question from './assessment-question'
import AssesmentStandards from 'components/quiz/components/assessment-standards'
import StandardsSearch from 'teacher/components/standards-search'

import FullScreenDialog from 'components/FullScreenDialog'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflow: 'hidden',
    padding: '15px 10px'
  },
  content: {
    display: 'flex',
    overflowY: 'hidden',
    flexGrow: 1,
  },
  left: {
    display: 'flex',
    flexShrink: 0
  },
  right: {
    flexGrow: 1,
    display: 'flex',
    marginLeft: 8
  },
  dialog: {
    "& .MuiDialog-paperScrollPaper": {
      overflow: 'hidden',
      backgroundColor: '#ecf1f5'
    }
  }
}))

export default function Assessment ({context}) {

  const classes = useStyles()
  const location = useLocation()
  const {questionId, assessment, sectionId, sectionName, quizSections: sections = [], link} = context

  const inStandards = sectionName == 'standards'
  const isSection = sectionId != undefined && !questionId
  const isQuestion = questionId != undefined

  const [firstSection] = sections

  const redirecting = !inStandards && !isSection && !isQuestion

  const redirectTo = redirecting && firstSection && link({sectionId: firstSection.id})

  function handleSearchStandards(filters) {
    return updateState({
      quizStandardFiltersCalls: {$apply: i => i + 1},
      quizStandardFilters: mapValues(filters, v => ({$set: v}))
    })
  }
  const standardSearchClosePath = link(undefined,'/:languageId/:role/:page(quiz)/:assessment/:action/:sectionId?/:questionId?')
  return redirecting && redirectTo
    ? (<Redirect to={redirectTo} />)
    : (<FullScreenDialog className={classes.dialog} open={true}>
    <Box className={classes.root}>
      <StandardsSearch open={sectionName == 'standards-search'} closePath={standardSearchClosePath} onSearchStandards={handleSearchStandards} />
      <Header context={context} />
      <Properties context={context} />
      <Box className={classes.content}>
        <Box className={classes.left}>
          <Sections context={context} />
        </Box>
        <Box className={classes.right}>
          {inStandards && <AssesmentStandards />}
          {isSection && (<Section context={context} />)}
          {isQuestion && (<Question context={context} />)} 
        </Box>
      </Box>
    </Box>
  </FullScreenDialog>)
}
